var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJustMoon = function SvgJustMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.616 13.917q-1.014.198-2.08.2c-6.077 0-11.004-5.023-11.004-11.22q0-.748.094-1.471a9.16 9.16 0 0 0-2.59 6.411c0 5.03 3.999 9.106 8.931 9.106 2.64 0 5.012-1.167 6.649-3.026m.421-.09-.001-.001zM3.689.993v.001M16.8 12.796c.794-.188 1.538.622 1.038 1.277C16.014 16.463 13.167 18 9.968 18 4.461 18 0 13.45 0 7.837 0 4.79 1.316 2.056 3.4.193c.612-.548 1.449.162 1.311.981q-.14.841-.142 1.723c0 5.613 4.462 10.163 9.967 10.163a9.8 9.8 0 0 0 2.264-.264",
    clipRule: "evenodd"
  })));
};
export default SvgJustMoon;